import { useState } from "react";
import { Avatar } from "./common";

/** The provider's avatar picture, or the identicon when there is none or it fails to load. */
export function AvatarImage({ src, name, size = 20 }: { src: string; name: string; size?: number }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <Avatar name={name} size={size} agent={false} />;
  return (
    <img
      src={src}
      alt=""
      title={name}
      width={size}
      height={size}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className="inline-block shrink-0 rounded-full border border-border-muted align-middle"
    />
  );
}
